import {createClient} from '@sanity/client'

export const client = createClient({
  projectId: '22nbnfs0', // find this in sanity.json or sanity manage
  dataset: 'production', // or "development" if that’s where your content is
  apiVersion: '2025-09-16', // use today's date
  useCdn: false, // false if you want the latest changes immediately
  token: undefined, // only needed for write access, leave undefined for read-only
})
